module.exports = __webpack_public_path__ + "static/media/oa-icon.bdd9b85d.png";